import { BadgeVariant, EyeIcon } from '@fagmobler/ui';
import { Badge } from '@fagmobler/ui';
import clsx from 'clsx';
import { PropsWithChildren } from 'react';

type ProductStatusProps = PropsWithChildren & {
  badgeVariant: BadgeVariant | 'eye';
  badgeText?: string;
};

export default function ProductStatus({
  badgeVariant,
  badgeText,
  children,
}: ProductStatusProps) {
  return (
    <div className="flex flex-col gap-1 max-w-[40%]">
      <div className="flex gap-1 items-center">
        {badgeVariant === 'eye' ? (
          <EyeIcon className="w-4 h-4 text-neutral-70 gap-1" />
        ) : (
          <Badge
            size="xs"
            variant={badgeVariant}
            className={clsx('h-3 w-3 gap-1 flex-shrink-0')}
          />
        )}
        <span className="body-xs">{badgeText ?? children}</span>
      </div>
    </div>
  );
}
